<script setup>
useUtmAttributionCapture()
</script>
<template>
  <main>
    <slot />
  </main>
</template>